<template lang="pug">
  .history-color
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container
        .history-label Hexadecimal
        div {{ dataOriginal.hexadecimal }}
      .history-container(v-if="dataOriginal.spanish")
        .history-label Color Spanish
        div {{ capitalize(dataOriginal.spanish) }}
      .history-container(v-if="dataOriginal.active || dataOriginal.active === false")
        .history-label Active
        div {{ dataOriginal.active }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryColor',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/color/History.vue